var render, staticRenderFns
import script from "./VatNumber.vue?vue&type=script&lang=js&"
export * from "./VatNumber.vue?vue&type=script&lang=js&"
import style0 from "./VatNumber.vue?vue&type=style&index=0&id=bf122b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf122b70",
  null
  
)

export default component.exports